import { container, TYPES } from '@/core/container'
import { createApiConfig, createGraphQLConfig, ApiConfig, GraphQLConfig } from '@/infrastructure/http/config'
import { AxiosHttpClient } from '@/infrastructure/http/axiosClient'
import { ApolloGraphQLClient } from '@/infrastructure/graphql/apolloClient'

export const setupInfrastructureBindings = () => {
  // Configuration
  const apiConfig = createApiConfig()
  const graphqlConfig = createGraphQLConfig(apiConfig)
  
  container.registerInstance(TYPES.ApiConfig, apiConfig)
  container.registerInstance(TYPES.GraphQLConfig, graphqlConfig)

  // HTTP Clients - only register if not already present
  if (!container.has(TYPES.AxiosClient)) {
    container.registerFactory(TYPES.AxiosClient, () => {
      const config = container.resolve(TYPES.ApiConfig) as ApiConfig
      return new AxiosHttpClient(config)
    })
  }

  if (!container.has(TYPES.GraphQLClient)) {
    container.registerFactory(TYPES.GraphQLClient, () => {
      const config = container.resolve(TYPES.GraphQLConfig) as GraphQLConfig
      return new ApolloGraphQLClient(config)
    })
  }
}